<section id="services">
    <!-- Section Content -->
    <div class="box-grey">
        <div class="wrapper">
            <div class="row margin-none col-half">
                <div class="col-md-4 col-sm-12 half padding-all">
                    <!-- <p><img src="assets/img/works-1-big.png" alt="Services" class="img-full"></p> -->
                    <h1 class="title-big letter-spacing line-bottom left">ATM सुविधा </h1>
                    <h5>
                        ATM सुविधा सर्व शाखेत उपलब्ध आहे. लाभ घेण्यासाठी KYC पूर्ण करणे अनिवार्य राहील.
                    </h5>
                    <p><a href="https://nmpksbank.in/assets/kyc.pdf" target="_black">Click here to KYC</a></p>
                    <div class="space "></div>
                    <p><a routerLink="/contact " class="btn btn-dark letter-spacing ">संपर्क</a></p>
                </div>

                <div class="col-md-8 col-sm-12 half padding-all box-white ">
                    <app-branch-address></app-branch-address>
                </div>
            </div>
        </div>
    </div>
    <!-- Section Content End -->
</section>